// utils/exportToExcel.js
import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename) => {
  // Initialize a new workbook
  const wb = XLSX.utils.book_new();

  // Process meta data
  if (data.meta) {
    const metaSheet = XLSX.utils.json_to_sheet([data.meta], { header: Object.keys(data.meta) });
    XLSX.utils.book_append_sheet(wb, metaSheet, 'Meta Data');
  }

  // Process templateDetails data
  if (data.templateDetails) {
    const templateDetailsSheet = XLSX.utils.json_to_sheet(data.templateDetails, { header: Object.keys(data.templateDetails[0]) });
    XLSX.utils.book_append_sheet(wb, templateDetailsSheet, 'Template Details');
  }

  // Write workbook to binary string
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  
  // Convert binary string to a blob and create a downloadable link
  const blob = new Blob([s2ab(wbout)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Helper function to convert string to ArrayBuffer
const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
};
